import type { WordPackDefinition } from "./types";

// Classic party game words (official 400-word set)
export const CLASSIC_WORDS = [
  // A
  "AFRICA", "AGENT", "AIR", "ALIEN", "ALPS", "AMAZON", "AMBULANCE", "AMERICA", "ANGEL", "ANTARCTICA",
  "APPLE", "ARM", "ATLANTIS", "AUSTRALIA", "AZTEC",
  // B
  "BACK", "BALL", "BAND", "BANK", "BAR", "BARK", "BAT", "BATTERY", "BEACH", "BEAR",
  "BEAT", "BED", "BEIJING", "BELL", "BELT", "BERLIN", "BERMUDA", "BERRY", "BILL", "BLOCK",
  "BOARD", "BOLT", "BOMB", "BOND", "BOOM", "BOOT", "BOTTLE", "BOW", "BOX", "BRIDGE",
  "BRUSH", "BUCK", "BUFFALO", "BUG", "BUGLE", "BUTTON",
  // C
  "CALF", "CANADA", "CAP", "CAPITAL", "CAR", "CARD", "CARROT", "CASINO", "CAST", "CAT",
  "CELL", "CENTAUR", "CENTER", "CHAIR", "CHANGE", "CHARGE", "CHECK", "CHEST", "CHICK", "CHINA",
  "CHOCOLATE", "CHURCH", "CIRCLE", "CLIFF", "CLOAK", "CLOCK", "CLUB", "CODE", "COLD", "COMIC",
  "COMPOUND", "CONCERT", "CONDUCTOR", "CONTRACT", "COOK", "COPPER", "COTTON", "COURT", "COVER", "CRANE",
  "CRASH", "CRICKET", "CROSS", "CROWN", "CYCLE", "CZECH",
  // D
  "DANCE", "DATE", "DAY", "DEATH", "DECK", "DEGREE", "DIAMOND", "DICE", "DINOSAUR", "DISEASE",
  "DOCTOR", "DOG", "DRAFT", "DRAGON", "DRESS", "DRILL", "DROP", "DUCK", "DWARF",
  // E
  "EAGLE", "EGYPT", "EMBASSY", "ENGINE", "ENGLAND", "EUROPE", "EYE",
  // F
  "FACE", "FAIR", "FALL", "FAN", "FENCE", "FIELD", "FIGHTER", "FIGURE", "FILE", "FILM",
  "FIRE", "FISH", "FLUTE", "FLY", "FOOT", "FORCE", "FOREST", "FORK", "FRANCE",
  // G
  "GAME", "GAS", "GENIUS", "GERMANY", "GHOST", "GIANT", "GLASS", "GLOVE", "GOLD", "GRACE",
  "GRASS", "GREECE", "GREEN", "GROUND",
  // H
  "HAM", "HAND", "HAWK", "HEAD", "HEART", "HELICOPTER", "HIMALAYAS", "HOLE", "HOLLYWOOD", "HONEY",
  "HOOD", "HOOK", "HORN", "HORSE", "HORSESHOE", "HOSPITAL", "HOTEL",
  // I
  "ICE", "ICE CREAM", "INDIA", "IRON", "IVORY",
  // J
  "JACK", "JAM", "JET", "JUPITER",
  // K
  "KANGAROO", "KETCHUP", "KEY", "KID", "KING", "KIWI", "KNIFE", "KNIGHT",
  // L
  "LAB", "LAP", "LASER", "LAWYER", "LEAD", "LEMON", "LEPRECHAUN", "LIFE", "LIGHT", "LIMOUSINE",
  "LINE", "LINK", "LION", "LITTER", "LOCH NESS", "LOCK", "LOG", "LONDON", "LUCK",
  // M
  "MAIL", "MAMMOTH", "MAPLE", "MARBLE", "MARCH", "MASS", "MATCH", "MERCURY", "MEXICO", "MICROSCOPE",
  "MILLIONAIRE", "MINE", "MINT", "MISSILE", "MODEL", "MOLE", "MOON", "MOSCOW", "MOUNT", "MOUSE",
  "MOUTH", "MUG",
  // N
  "NAIL", "NEEDLE", "NET", "NEW YORK", "NIGHT", "NINJA", "NOTE", "NOVEL", "NURSE", "NUT",
  // O
  "OCTOPUS", "OIL", "OLIVE", "OLYMPUS", "OPERA", "ORANGE", "ORGAN",
  // P
  "PALM", "PAN", "PANTS", "PAPER", "PARACHUTE", "PARK", "PART", "PASS", "PASTE", "PENGUIN",
  "PHOENIX", "PIANO", "PIE", "PILOT", "PIN", "PIPE", "PIRATE", "PISTOL", "PIT", "PITCH",
  "PLANE", "PLASTIC", "PLATE", "PLATYPUS", "PLAY", "PLOT", "POINT", "POISON", "POLE", "POLICE",
  "POOL", "PORT", "POST", "POUND", "PRESS", "PRINCESS", "PUMPKIN", "PUPIL", "PYRAMID",
  // Q
  "QUEEN",
  // R
  "RABBIT", "RACKET", "RAY", "REVOLUTION", "RING", "ROBIN", "ROBOT", "ROCK", "ROME", "ROOT",
  "ROSE", "ROULETTE", "ROUND", "ROW", "RULER",
  // S
  "SATELLITE", "SATURN", "SCALE", "SCHOOL", "SCIENTIST", "SCORPION", "SCREEN", "SCUBA DIVER", "SEAL", "SERVER",
  "SHADOW", "SHAKESPEARE", "SHARK", "SHIP", "SHOE", "SHOP", "SHOT", "SINK", "SKYSCRAPER", "SLIP",
  "SLUG", "SMUGGLER", "SNOW", "SNOWMAN", "SOCK", "SOLDIER", "SOUL", "SOUND", "SPACE", "SPELL",
  "SPIDER", "SPIKE", "SPINE", "SPOT", "SPRING", "SPY", "SQUARE", "STADIUM", "STAFF", "STAMP",
  "STAR", "STATE", "STICK", "STOCK", "STRAW", "STREAM", "STRIKE", "STRING", "SUB", "SUIT",
  "SUPERHERO", "SWING", "SWITCH",
  // T
  "TABLE", "TABLET", "TAG", "TAIL", "TAP", "TEACHER", "TELESCOPE", "TEMPLE", "THEATER", "THIEF",
  "THUMB", "TICK", "TIE", "TIME", "TOKYO", "TOOTH", "TORCH", "TOWER", "TRACK", "TRAIN",
  "TRIANGLE", "TRIP", "TRUNK", "TUBE", "TURKEY",
  // U
  "UNDERTAKER", "UNICORN",
  // V
  "VACUUM", "VAN", "VET",
  // W
  "WAKE", "WALL", "WAR", "WASHER", "WASHINGTON", "WATCH", "WATER", "WAVE", "WEB", "WELL",
  "WHALE", "WHIP", "WIND", "WITCH", "WORM",
  // Y
  "YARD",
];

export const CLASSIC_SEMANTIC_FAMILIES: string[][] = [
  ["KING", "QUEEN", "PRINCESS", "KNIGHT", "CROWN"],
  ["DOG", "CAT", "HORSE", "BEAR", "LION", "RABBIT", "MOUSE"],
  ["DOCTOR", "NURSE", "HOSPITAL", "LAB", "DISEASE"],
  ["CAR", "TRAIN", "PLANE", "JET", "HELICOPTER", "SHIP", "SUB"],
  ["MOON", "STAR", "MERCURY", "JUPITER", "SATURN"],
  ["APPLE", "ORANGE", "LEMON", "KIWI"],
  ["FILM", "COMIC", "HOLLYWOOD", "THEATER", "OPERA", "CONCERT"],
  ["BANK", "BILL", "POUND", "GOLD", "DIAMOND", "STOCK", "CONTRACT"],
  ["TABLE", "CHAIR", "BED", "CLOCK", "BOTTLE", "GLASS", "BRUSH"],
  ["THIEF", "LAWYER", "POLICE", "COURT", "CELL"],
];

export const CLASSIC_PACK: WordPackDefinition = {
  key: "classic",
  words: CLASSIC_WORDS,
  semanticFamilies: CLASSIC_SEMANTIC_FAMILIES,
};
